import React, { useContext } from 'react';
import styled from 'styled-components';
import DataToBeDeleted from '../../rules/edit/data_to_be_deleted';
import Errors from '../../shared/errors';
import { DataRetentionRulesContext } from '../context';

type Props = {
  dataToDelete: Array<string>;
  onChangeDataToDelete: any;
};

export default function DeletionConfiguration(props: Props) {
  const { dataToDelete, onChangeDataToDelete } = props;
  const { errors, meta } = useContext(DataRetentionRulesContext);

  // @ts-expect-error - TS2339 - Property 'data_to_be_deleted' does not exist on type '{}'.
  const deletionError = errors.data_to_be_deleted &&
    // @ts-expect-error - TS2339 - Property 'data_to_be_deleted' does not exist on type '{}'.
    errors.data_to_be_deleted.length && (
      // @ts-expect-error - TS2339 - Property 'data_to_be_deleted' does not exist on type '{}'.
      <Errors errors={errors.data_to_be_deleted} />
    );

  return (
    <Container>
      <DataToBeDeleted
        candidateDataPath={meta.candidate_data_path}
        error={deletionError}
        onDataToBeDeletedChange={(field: string, toDelete: boolean) => {
          if (toDelete) {
            onChangeDataToDelete([...dataToDelete, field]);
          } else {
            onChangeDataToDelete(dataToDelete.filter((id) => id !== field));
          }
        }}
        selectedCandidateData={dataToDelete}
      />
    </Container>
  );
}

const Container = styled.div`
  box-sizing: content-box;
  width: 75%;
`;
